import { AxiosError } from 'axios';
import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useAuth } from '@/contexts/AuthContext';
import { useGenerateVtexAffiliateURL } from '@/hooks/useGenerateVtexAffiliateUrl';

export function AffiliateURL() {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Settings.components.Vtex.components.Affiliate.affiliateUrl',
  });

  const [isCopied, setIsCopied] = useState(false);

  const { user } = useAuth();

  const affiliateUrl = `https://catalog.api.fashionai.dev/api${user?.customer.vtexAffiliateUrl}`;

  const { generateVtexAffiliateURL, isLoading } = useGenerateVtexAffiliateURL();

  const isFreemium = user?.customer.freemium;

  async function handleGenerateVtexAffiliateURL() {
    try {
      await generateVtexAffiliateURL();
    } catch (error) {
      if (isFreemium && error instanceof AxiosError) {
        if (error.response?.status === 403) {
          toast.error(t('freemiumError'));
          return;
        } else {
          toast.error(t('generateError'));
          return;
        }
      }
      toast.error(t('generateError'));
    }
  }

  function handleCopyVtexAffiliateUrl() {
    setIsCopied(true);
    navigator.clipboard.writeText(affiliateUrl);
    toast.success(t('toast.success'));
  }

  return (
    <div className="inline-flex items-center gap-2">
      <strong className="text-nowrap">{t('label')}</strong>

      {user?.customer.vtexAffiliateUrl && (
        <>
          <Input
            className="w-[360px]"
            value={affiliateUrl}
            onChange={() => {}}
          />

          <Button onClick={handleCopyVtexAffiliateUrl}>
            {isCopied ? <Check /> : <Copy />}
          </Button>
        </>
      )}

      {!user?.customer.vtexAffiliateUrl && (
        <Button disabled={isLoading} onClick={handleGenerateVtexAffiliateURL}>
          {isLoading ? t('generatingButton') : t('generateButton')}
        </Button>
      )}
    </div>
  );
}
